<div class="fill-height p-2">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
  <mat-card>
    <form class="h-100 d-flex flex-column p-2" [formGroup]="form" (submit)="onSavePaper()" *ngIf="!isLoading">
      <mat-form-field>
        <mat-label>Paper Name</mat-label>
        <input matInput type="text" formControlName="paperName" placeholder="Paper Name">
        <mat-error *ngIf="form.get('paperName').invalid">Please enter a Paper Name.</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Paper Width (cm)</mat-label>
        <input matInput type="number" formControlName="paperWidth" placeholder="Paper Width">
        <mat-error *ngIf="form.get('paperWidth').invalid">Please enter a Paper Width.</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Paper Height (cm)</mat-label>
        <input matInput type="number" formControlName="paperHeight" placeholder="Paper Height">
        <mat-error *ngIf="form.get('paperHeight').invalid">Please enter a Paper Height.</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Paper Weight (g)</mat-label>
        <input matInput type="number" formControlName="paperWeight" placeholder="Paper Weight">
        <mat-error *ngIf="form.get('paperWeight').invalid">Please enter a Paper Weight.</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Paper's Printer Code</mat-label>
        <input matInput type="text" formControlName="paperPrinterCode" placeholder="Paper Printer Code">
        <mat-error *ngIf="form.get('paperPrinterCode').invalid">Please enter a Paper Printer Code.</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Paper's Printer Quality (1-5)</mat-label>
        <input matInput type="number" formControlName="paperPrinterQuality" placeholder="Paper Printer Quality">
        <mat-error *ngIf="form.get('paperPrinterQuality').invalid">Please enter a Paper Printer Quality.</mat-error>
      </mat-form-field>
      <mat-checkbox [(ngModel)]="form.value.isExpress" formControlName="isExpress">isExpress</mat-checkbox>
      <mat-checkbox [(ngModel)]="form.value.isPlotter" formControlName="isPlotter">isPlotter</mat-checkbox>
      <mat-checkbox [(ngModel)]="form.value.isPh" formControlName="isPh">isPh</mat-checkbox>

      <button #hiddenSubmitBtn type="submit" style="display: none;"></button>

    </form>
  </mat-card>
</div>

<div class="p-2">
  <div class="d-flex flex-column flex-md-row gap-2">
    <button class="w-100 rounded-pill" mat-raised-button color="primary" type="button" (click)="submitForm()">
      Save Paper
    </button>
    <button class="w-100 rounded-pill" *ngIf="isModeEdit" mat-raised-button color="primary" type="button"
      (click)="backToPapers()">
      Don't Save Changes
    </button>
    <button class="w-100 rounded-pill" mat-raised-button type="button" (click)="toPapersList()">
      Paper List
    </button>
  </div>
</div>